import React from "react";
import AccountDashboard from "./components/AccountDashboard";
import CreateAccount from "./components/CreateAccount";
import AssignedPlans from "./components/AssignedPlans";
import CreatePlan from "./components/CreatePlan";
import AssignServiceToPlan from "./components/AssignServiceToPlan";
import CustomiseServiceProvider from "./components/CustomiseServiceProvider";
import WhitelistUser from "./components/WhitelistUser";
import AdvancedSponsorshipRule from "./components/AdvancedSponsorshipRule";

class AccountModule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      view: 0,
      props: null,
      // view: 2,
      // props: {
      //   mode: "assign",
      //   accountId: "688b10dae79d9a2cc970ee2a",
      // },
      // view: 3,
      // props: {
      //   mode: "create",
      //   accountId: "686ceb7146809a2cde0a2d21",
      // },
      dashboardKey: 0,
      dashboardKeyReload: 0,
    };
  }

  setView = (v, p) => {
    this.setState({ view: v, props: p });
  };
  resetDashboard = () => {
    this.setState((prev) => ({ dashboardKey: prev.dashboardKey + 1 }));
  };
  resetDashboardReload = () => {
    this.setState((prev) => ({
      dashboardKeyReload: prev.dashboardKeyReload + 1,
    }));
  };

  render() {
    return (
      <>
        <div style={{ display: this.state.view === 0 ? "block" : "none" }}>
          <AccountDashboard
            key={this.state.dashboardKey}
            setView={this.setView}
            data={this.state.props}
            history={this.props.history}
            dashboardKeyReload={this.state.dashboardKeyReload}
          />
        </div>
        {this.state.view === 1 ? (
          <CreateAccount
            setView={this.setView}
            data={this.state.props}
            resetDashboardReload={this.resetDashboardReload}
          />
        ) : this.state.view === 2 ? (
          <AssignedPlans setView={this.setView} data={this.state.props} />
        ) : this.state.view === 3 ? (
          <CreatePlan setView={this.setView} data={this.state.props} />
        ) : this.state.view === 4 ? (
          <AssignServiceToPlan setView={this.setView} data={this.state.props} />
        ) : this.state.view === 5 ? (
          <CustomiseServiceProvider
            setView={this.setView}
            data={this.state.props}
          />
        ) : this.state.view === 6 ? (
          <WhitelistUser setView={this.setView} data={this.state.props} />
        ) : this.state.view === 7 ? (
          <AdvancedSponsorshipRule
            setView={this.setView}
            data={this.state.props}
          />
        ) : (
          <></>
        )}
      </>
    );
  }
}

export default AccountModule;
